


















































































































































































































































import { vxm } from '@/store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Referrals from './Referrals.vue';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import { BFormFile } from 'bootstrap-vue/es/components';
import { ResumePayload } from '../models/jobs/resumepayload';
import { JobTokenPayload } from '../models/jobs/jobTokenPayload';
import {
  QuestionnaireResponse,
  UserQuestionResponse,
} from '../models/jobs/questionnaireresponse';
import { Questionnaire } from '../models/jobs/questionnaire';
import { QuestionResponseData } from '../models/jobs/questionnaireresponse';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../router';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  name: 'Questionnaire',
  components: {
    Jobseeker,
    Myreferrals,
    Referrals,
  },
})
export default class QuestionnaireComponent extends Vue {
  private resumePayload: ResumePayload = new ResumePayload();
  private showDetail: boolean = false;
  private supportingInfo: any;
  private questionnaire: Questionnaire = vxm.jobs.Questionnaire;
  private questionnaireResponse: QuestionnaireResponse = vxm.jobs.QAResponse;
  private showData: boolean = false;
  private multipleTypeQuestionValues: string[] = [];
  $wlToastr: any;
  $moment: any;

  mounted() {
    const jobid = this.$route.params.JobID;
    vxm.jobs.getAnonymousJobByID(jobid);
  }

  processPayload() {
    console.log(this.questionnaireResponse);
    setTimeout(() => {
      this.saveQuesionnaireResponse();
    }, 50);
  }

  getDistance(job: Job) {
    if (job.distance > 0.1) {
      return job.distance.toFixed(1);
    } else {
      return '< 0.1';
    }
  }
  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }
  get globalRefCode() {
    const RefCode = vxm.referrals.globalRefCode;
    console.log('RefCode', [RefCode]);
    this.questionnaireResponse.referralCode = RefCode;
    return RefCode;
  }
  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get QuestionnaireData() {
    return vxm.jobs.Questionnaire.questions;
  }

  getQuestionnaireReponsData() {
    this.questionnaireResponse = vxm.jobs.QAResponse;
  }

  get jobDetail(): Job[] {
    const jobList: Job[] = [];
    jobList.push(vxm.jobs.AnonymousJobByID);
    return jobList;
  }

  checkRadioValue(i, value) {
    this.questionnaireResponse.questionResponseData[
      i
    ].userQuestionResponse.userAnswerList[0] = value;
    console.log(this.questionnaireResponse);
  }

  checkValue(i, x, answerMasterID) {
    const value = this.multipleTypeQuestionValues.findIndex((elm) => {
      return elm === answerMasterID;
    });
    if (value === -1) {
      this.multipleTypeQuestionValues.push(answerMasterID);
    } else {
      this.multipleTypeQuestionValues.splice(value, 1);
    }
    this.questionnaireResponse.questionResponseData[
      i
    ].userQuestionResponse.userAnswerList = this.multipleTypeQuestionValues;
    console.log(this.questionnaireResponse);
  }
  setSimpleText(i, evt) {
    this.questionnaireResponse.questionResponseData[
      i
    ].userQuestionResponse.questionTextResponse = evt.target.value;
    console.log(i, this.questionnaireResponse);
  }

  saveQuesionnaireResponse() {
    if (!this.validateUserQuestionResponse()) {
      this.$wlToastr(
        'error',
        'Please enter mandatory fields.',
        this.$t('MyJobListing_JobApplication'),
      );
    } else {
      const vm = this;
      const jobId = this.$route.params.JobID;
      const jtp = new JobTokenPayload();
      jtp.token = vxm.users.getToken;
      jtp.jobID = parseInt(jobId, 10);
      this.questionnaireResponse.userId = vxm.users.myUserProfile.userId + '';
      this.questionnaireResponse.referralCode = this.globalRefCode;
      vxm.jobs.setQAResponse(this.questionnaireResponse);

      const respPromise: any = vxm.jobs.saveQuestionnaire(jtp);
      Promise.all([respPromise]).then((values) => {
        if (values[0]) {
          if (values[0].success) {
            const successMessage = this.$t('jobs.successfully.applied');
            vm.$wlToastr('success', successMessage, vm.$t('MyJobListing_JobApplication'));
            vxm.jobs.setAppliedJob(jobId);
            router.push({ name: 'JobApplicationSuccess', params: { jobId } });
          }
          if (!values[0].success) {
            const errorMessageText =
              values[0].errorMessage !== ''
                ? values[0].errorMessage
                : 'Failure while Saving Questions';
            vm.$wlToastr('error', errorMessageText, vm.$t('MyJobListing_JobApplication'));
          }
        }
      });
    }
  }

  getSupportingInfo() {
    const jobId = this.$route.params.JobID;
    const jtp = new JobTokenPayload();
    jtp.token = vxm.users.getToken;
    jtp.jobID = parseInt(jobId, 10);
    vxm.jobs.getSupportingInfo(jtp);
  }

  goToResumeUpload() {
    this.$router.push({
      name: 'ResumeUpload',
      params: { JobID: this.$route.params.JobID },
    });
  }

  setName() {
    setTimeout(() => {
      this.resumePayload.resume.resumename = this.resumePayload.resumefile.name;
    }, 50);
  }

  JobID() {
    return parseInt(this.$route.params.JobID, 10);
  }

  toggleReferrals() {
    this.showDetail = !this.showDetail;
  }

  getToggleValue() {
    return this.showDetail;
  }

  truncate(str: string, len: number, suffix: string) {
    if (str.length > len) {
      return str.substring(0, len) + suffix;
    } else {
      return str;
    }
  }

  renderDate(xDate: Date): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return (
        'STARTING: ' +
        this.$moment(xDate).format(vxm.jobs.getCompanyDateFormat.toUpperCase())
      );
    }
    return 'STARTING: ' + this.$moment(xDate).format('DD-MMM-YYYY');
  }

  isNumberOrAlphaNumeric(evt, answerTypeValue) {
    if (answerTypeValue === '01') {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    } else if (answerTypeValue === '03') {
      if (
        (evt.keyCode >= 48 && evt.keyCode <= 57) ||
        (evt.keyCode >= 65 && evt.keyCode <= 90) ||
        (evt.keyCode >= 97 && evt.keyCode <= 122)
      )
        return true;
    }
    return false;
  }

  validateUserQuestionResponse(): boolean {
    let result = true;
    const questionRequiredMap = new Map();
    this.QuestionnaireData.forEach((element) => {
      if (element.questionRequired) {
        questionRequiredMap.set(element.questionID, element.questionType);
      }
    });
    this.questionnaireResponse.questionResponseData.forEach((element) => {
      if (questionRequiredMap.has(parseInt(element.questionID, 10))) {
        console.log([questionRequiredMap]);
        const questionType = questionRequiredMap.get(
          parseInt(element.questionID, 10),
        );

        if (questionType === '01') {
          // Multiple Type Question
          for (
            let i = 0, l = element.userQuestionResponse.userAnswerList.length;
            i < l;
            i++
          ) {
            if (element.userQuestionResponse.userAnswerList[i]) {
              result = true;
              break;
            } else {
              result = false;
            }
          }
        } else if (questionType === '02') {
          // Paragraph Question
          if (!element.userQuestionResponse.questionTextResponse) {
            result = false;
          }
        } else if (questionType === '03') {
          // Radio Question
          for (
            let i = 0, l = element.userQuestionResponse.userAnswerList.length;
            i < l;
            i++
          ) {
            if (element.userQuestionResponse.userAnswerList[i]) {
              result = true;
              break;
            } else {
              result = false;
            }
          }
        } else if (questionType === '04') {
          // short text
          if (!element.userQuestionResponse.questionTextResponse) {
            result = false;
          }
        }
      }
    });
    console.log('validation result', result);
    return result;
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
}
